import React from 'react';
import Typography from '@material-ui/core/Typography';

export default function About() {

  return (
    <div>  
    <Typography variant="h6">
      About
    </Typography>
    </div>
  );
}
